import { useEffect, useState } from 'react';

/**
 * Returns `value` only once it has stayed unchanged for `delayMs` — every change restarts
 * the wait. Compared by identity, so pass a primitive (serialize objects first) or the
 * value never settles.
 */
export const useDebouncedValue = <T>(value: T, delayMs: number): T => {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    if (value === settled) return;

    const timeout = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timeout);
  }, [value, settled, delayMs]);

  return settled;
};

export default useDebouncedValue;
